import { useState, useEffect, useRef, useContext } from 'react'
import { ReactSession } from 'react-client-session'
import { useHistory } from 'react-router-dom'

import Toast from '@base/Toast'
import Loading from '@base/Loading'
import ProcessoService from '@services/ProcessoService'
import { redirectPaginaInicialDeAcordoComPerfil } from '@helpers/ProcessoHelper'
import { ProcessoContext } from '@contexts/ProcessoContext'

export const Inicio = () => {
	const [loading, setLoading] = useState(true);

  const { processo, setProcesso } =  useContext(ProcessoContext);

	const toastRef = useRef(null);

  const history = useHistory();

	useEffect(() => {
    setLoading(true);
    console.log("xxxx");
    ProcessoService.buscarProcessoEmAndamento().then(resultado => {
      if (resultado.status === 200) {
        setProcesso(resultado.data);
      }
    })
    .catch(error => toastRef.current.show("error", "Ocorreu um Problema ao Buscar Processo Ativo para Redirecionamento!"))
    .finally(() => setLoading(false));
  }, [setProcesso]);

  const redirectParaProcesso = () => {
    ReactSession.set("responsavel_triagem", "");
    ReactSession.set("contador_triagem", 0);

    redirectPaginaInicialDeAcordoComPerfil(history,processo.id);

  }

	return (
		<>
			<Toast ref={toastRef} />

      { loading ?
          <Loading />
        : processo.id ?
          redirectParaProcesso()
        : null
      }
		</>
	);
}

export default Inicio;
